import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { CalendarClock, ArrowRight } from "@/components/icons";

export default function CotaPendenteBanner({ compact = false }) {
  const navigate = useNavigate();
  const [status, setStatus] = useState(null);

  useEffect(() => {
    api.get("/cotas/status").then((r) => setStatus(r.data)).catch(() => {});
  }, []);

  if (!status?.pendente) return null;
  const mes = (status.mes_label || "").split(" ")[0].toLowerCase();

  if (compact) {
    return (
      <button onClick={() => navigate("/equipe")} data-testid="cota-pendente-banner"
        className="mb-4 w-full flex items-center gap-2 rounded-lg border border-warn/20 bg-warn/10 px-3 py-2 text-left"
      >
        <CalendarClock className="w-4 h-4 text-warn shrink-0" />
        <span className="text-xs text-navy flex-1 min-w-0 truncate">
          <b>Cotas de {mes} pendentes</b> · {status.sem_cota} de {status.total_vendedores}
        </span>
        <ArrowRight className="w-3.5 h-3.5 text-warn shrink-0" />
      </button>
    );
  }

  return (
    <div className="mb-5 flex items-center gap-3 rounded-xl border border-warn/20 bg-warn/10 px-4 py-3" data-testid="cota-pendente-banner">
      <CalendarClock className="w-4 h-4 text-warn shrink-0" />
      <div className="flex-1 min-w-0 text-sm text-navy">
        <span className="font-medium">Cotas de {mes} ainda não cadastradas.</span>
        <span className="text-muted-foreground"> {status.sem_cota} de {status.total_vendedores} vendedores ainda estão sem cota em {mes}.</span>
      </div>
      <button onClick={() => navigate("/equipe")} data-testid="cota-cadastrar-btn"
        className="shrink-0 inline-flex items-center gap-1.5 text-sm font-semibold text-warn hover:text-warn/80">
        Cadastrar cotas <ArrowRight className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
